(() => {
  if (window.__AOW_UNIT_PRICE_FALLBACK__) return;
  window.__AOW_UNIT_PRICE_FALLBACK__ = true;

  const parseUnitData = (text = '') => {
    const match = String(text).match(/(\d+(?:[.,]\d+)?)\s*(stems?|bunch(?:es)?|trays?)/i);
    if (!match) return null;

    const count = Number.parseFloat(match[1].replace(',', '.'));
    if (!Number.isFinite(count) || count <= 0) return null;

    const rawUnit = match[2].toLowerCase();
    let unit = 'stem';
    if (rawUnit.startsWith('bunch')) unit = 'bunch';
    if (rawUnit.startsWith('tray')) unit = 'tray';

    return { count, unit };
  };

  const parseMoney = (text = '') => {
    let numeric = String(text).replace(/[^0-9,.-]/g, '');
    if (!numeric) return null;

    if (numeric.includes(',') && numeric.includes('.')) {
      numeric = numeric.replace(/,/g, '');
    } else if (numeric.includes(',') && !numeric.includes('.')) {
      numeric = numeric.replace(',', '.');
    }

    const value = Number.parseFloat(numeric);
    return Number.isFinite(value) ? value : null;
  };

  const formatMoney = (value) => {
    const currency = window.Shopify?.currency?.active || 'GBP';
    const locale = document.documentElement.lang || 'en-GB';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (_) {
      return `£${value.toFixed(2)}`;
    }
  };

  const pluralUnit = (unit, count) => {
    if (count === 1) return unit;
    if (unit === 'bunch') return 'bunches';
    return `${unit}s`;
  };

  const decorateMainVariantRows = (root = document) => {
    root.querySelectorAll?.('.variant-option').forEach((row) => {
      const existing = row.querySelector('.variant-unit-price');
      if (existing?.textContent?.trim()) return;

      const sourceText = [
        row.querySelector('.variant-title')?.textContent,
        row.querySelector('.variant-pack-size')?.textContent,
        row.dataset.packLabel,
      ].filter(Boolean).join(' ');

      const unitData = parseUnitData(sourceText);
      if (!unitData) return;

      const price = parseMoney(row.querySelector('.variant-price')?.textContent);
      if (price === null) return;

      const unitPriceText = `${formatMoney(price / unitData.count)} per ${unitData.unit}`;
      const wrap = row.querySelector('.variant-price-wrap');
      if (!wrap) return;

      const unitPrice = existing || document.createElement('span');
      unitPrice.className = 'variant-unit-price';
      unitPrice.textContent = unitPriceText;
      if (!existing) wrap.appendChild(unitPrice);

      if (!row.dataset.unitLabel) row.dataset.unitLabel = unitData.unit;
      if (!row.dataset.packLabel) {
        row.dataset.packLabel = `${unitData.count} ${pluralUnit(unitData.unit, unitData.count)}`;
      }
    });
  };

  const decorateQuickAdd = (root = document) => {
    root.querySelectorAll?.('[data-aow-variant]').forEach((button) => {
      if (button.dataset.unitPrice?.trim()) return;

      const sourceText = [
        button.querySelector('.aow-quick-add__variant-title')?.textContent,
        button.querySelector('.aow-quick-add__variant-pack')?.textContent,
        button.dataset.packLabel,
      ].filter(Boolean).join(' ');

      const unitData = parseUnitData(sourceText);
      if (!unitData) return;

      const price = parseMoney(
        button.dataset.variantPrice || button.querySelector('.aow-quick-add__variant-price')?.textContent
      );
      if (price === null) return;

      const formatted = formatMoney(price / unitData.count);
      button.dataset.unitPrice = `${formatted} per ${unitData.unit}`;

      if (!button.dataset.packLabel) {
        button.dataset.packLabel = `${unitData.count} ${pluralUnit(unitData.unit, unitData.count)}`;
      }

      const wrap = button.querySelector('.aow-quick-add__variant-price-wrap');
      if (wrap && !wrap.querySelector('.aow-quick-add__variant-unit')) {
        const unitPrice = document.createElement('span');
        unitPrice.className = 'aow-quick-add__variant-unit';
        unitPrice.textContent = button.dataset.unitPrice;
        wrap.appendChild(unitPrice);
      }

      if (button.classList.contains('is-selected')) {
        const overlay = button.closest('[data-aow-quick-add-overlay]');
        const selectedUnitPrice = overlay?.querySelector('[data-aow-selected-unit-price]');
        if (selectedUnitPrice) selectedUnitPrice.textContent = button.dataset.unitPrice;

        const packBadge = overlay?.querySelector('[data-aow-pack-badge]');
        if (packBadge) {
          packBadge.textContent = button.dataset.packLabel;
          packBadge.hidden = false;
        }
      }
    });
  };

  const decorateAll = (root = document) => {
    decorateMainVariantRows(root);
    decorateQuickAdd(root);
  };

  const start = () => {
    decorateAll(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          decorateAll(node);
        });
      });
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
